module.exports = __webpack_public_path__ + "static/media/general.359daec3.svg";